import {Card} from 'platform/components';

import {i18n} from '@dms/i18n';
import {hasSecondaryFuelType} from '@dms/shared';

import {VehicleForm as VFKit} from '../VehicleForm';

export function FuelGroup() {
  return (
    <>
      {/* Primary fuel */}
      <VFKit.PrimaryFuelChips />

      {/* Electric */}
      <VFKit.ShowWhen name="fuelType" value={['FUELTYPE_ELECTRIC']}>
        <Card variant="inlineGrey" title={i18n.t('entity.vehicle.labels.battery')}>
          <VFKit.Group data-testid="battery-data" columns={[1, 2, 4]}>
            <VFKit.Suspense>
              <VFKit.ElectricFields />
            </VFKit.Suspense>
          </VFKit.Group>
        </Card>
      </VFKit.ShowWhen>

      {/* Secondary fuel */}
      <VFKit.ShowWhen
        name="fuelType"
        condition={(fuelTypes) => hasSecondaryFuelType(fuelTypes?.[0])}
      >
        <VFKit.Suspense>
          <VFKit.SecondaryFuelChips />
        </VFKit.Suspense>

        <Card variant="inlineGrey">
          <VFKit.ShowWhen name="fuelType" value={['FUELTYPE_HYBRID']}>
            <VFKit.Suspense>
              <VFKit.HybridTypeChips />
            </VFKit.Suspense>
          </VFKit.ShowWhen>

          <VFKit.ShowWhen name="fuelType" condition={(value) => value?.[0] !== 'FUELTYPE_HYBRID'}>
            <VFKit.Group data-testid="revision-dates" columns={[1, 2]}>
              <VFKit.ShowWhen
                name="fuelType"
                condition={(value) => value?.[0] !== 'FUELTYPE_HYDROGEN'}
              >
                <VFKit.Field
                  type="apiDate"
                  name="gasRevisionValidUntil"
                  label={i18n.t('entity.vehicle.labels.gasRevisionValidUntil')}
                />
              </VFKit.ShowWhen>
              <VFKit.Field
                type="apiDate"
                name="pressureVesselValidUntil"
                label={i18n.t('entity.vehicle.labels.pressureVesselExpires')}
              />
            </VFKit.Group>
          </VFKit.ShowWhen>
        </Card>

        <VFKit.ShowWhen
          watchFields={['fuelType', 'hybridType']}
          condition={(values) =>
            values.fuelType?.[0] === 'FUELTYPE_HYBRID' &&
            (values.hybridType?.[0] === 'HYBRIDTYPE_FULL' ||
              values.hybridType?.[0] === 'HYBRIDTYPE_PHEV')
          }
        >
          <Card variant="inlineGrey" title={i18n.t('entity.vehicle.labels.battery')}>
            <VFKit.Group data-testid="battery-data" columns={[1, 2, 4]}>
              <VFKit.Suspense>
                <VFKit.ShowWhen name="hybridType" value={['HYBRIDTYPE_FULL']}>
                  <VFKit.ElectricFields isSimplified />
                </VFKit.ShowWhen>
                <VFKit.ShowWhen name="hybridType" value={['HYBRIDTYPE_PHEV']}>
                  <VFKit.ElectricFields />
                </VFKit.ShowWhen>
              </VFKit.Suspense>
            </VFKit.Group>
          </Card>
        </VFKit.ShowWhen>
      </VFKit.ShowWhen>
    </>
  );
}
